module.exports = __webpack_public_path__ + "img/cv.ade6e398.svg";